import { createFileRoute } from '@tanstack/react-router';
import { PatientTableView } from '../../state/patientSearchAtoms.ts';
import { PatientOverview } from '../components/PatientOverview.tsx';
import { CreateCase } from './components/CreateCase.tsx';

export const Route = createFileRoute('/patients/')({
  component: Patients,
});

const tbCaseTableViews = [PatientTableView.FINDINGS, PatientTableView.THERAPY, PatientTableView.CONTACT_TRACING];

function Patients() {
  return (
    <PatientOverview
      title="TB-Fälle"
      tableViews={tbCaseTableViews}
      createCaseButtonLabel="Neuer Fall"
      renderCreateDialog={({ open, onClose }) => <CreateCase open={open} onClose={onClose} isIndexPatient />}
    />
  );
}
